import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { LineitemSearchComponent } from "./lineitem-search/lineitem-search.component";
import { TickerSearchComponent } from "./ticker-search/ticker-search.component";
import { TextHighlightPipe } from "../text-highlight.pipe";
import { EllipsisPipe } from "../ellipsis.pipe";
import { IconsModule } from "@va/core-library/icons";
import { MultiSelectDropdownComponent } from "./multi-select-dropdown/multi-select-dropdown.component";
import { SingleSelectDropdownComponent } from "./single-select-dropdown/single-select-dropdown.component";
import { ArkContainerComponent } from "./ark-container/ark-container.component";
import { WatchlistDropdownComponent } from "./watchlist-dropdown/watchlist-dropdown.component";
import { YearTypeFilterComponent } from "./year-type-filter/year-type-filter.component";
import { ActivityFeedComponent } from "./activity-feed/activity-feed.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { RouterModule, Routes } from "@angular/router";
import { RemoveWhiteSpacesPipe } from "../remove-white-spaces.pipe";
import { MatListModule } from "@angular/material/list";
import { DragDropModule } from "@angular/cdk/drag-drop";
// import { AddRemoveSectionComponent } from './add-remove-section/add-remove-section.component';
import { AddModalSectionComponent } from "./add-modal-section/add-modal-section.component";
import { RemoveModalSectionComponent } from "./remove-modal-section/remove-modal-section.component";
import { CommonModalComponent } from "./common-modal/common-modal.component";
import { AccountingBasisComponent } from "./accounting-basis/accounting-basis.component";
import { AnalyticsComponent } from "./analytics/analytics.component";
import { HistoricalEstimatesComponent } from "./historical-estimates/historical-estimates.component";
import { PeriodsComponent } from "./periods/periods.component";
import { ValueRendererComponent } from "./value-renderer/value-renderer.component";
import { StepperBaseButtonComponent } from "./stepper-base-button/stepper-base-button.component";
import { AlertsModule } from "./alerts/alerts.module";
import { RightPanelSourceComponent } from "./right-panel-source/right-panel-source.component";
import { VisualizationsComponent } from "./visualizations/visualizations.component";
import { ExportToExcelComponent } from "./export-to-excel/export-to-excel.component";
import { NullCleanerPipe } from "./export-to-excel/export-to-excel.pipe";
import { SourceNameTableDisplayComponent } from "./source-name-table-display/source-name-table-display.component";
import { InferredDataSectionComponent } from "./inferred-data-section/inferred-data-section.component";
import { MultiSelectFilterComponent } from "./multi-select-filter/multi-select-filter.component";
import { DateRangeSelectComponent } from "./date-range-select/date-range-select.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { ComparativeAnalysisPopoverContentComponent } from "./comparative-analysis-popover-content/comparative-analysis-popover-content.component";
import { CustomSkeletonComponent } from "./custom-skeleton/custom-skeleton.component";
import { SourceTableComponent } from "./source-table/source-table.component";
import { LineItemModalComponent } from "./line-item-modal/line-item-modal.component";
import { LineitemWithSearchboxInDropdownComponent } from "./lineitem-with-searchbox-in-dropdown/lineitem-with-searchbox-in-dropdown.component";
import { GrowthRevisionFilterComponent } from "./growth-revision-filter/growth-revision-filter.component";
import { TickerFyInfoComponent } from "./ticker-fy-info/ticker-fy-info.component";
import { ExportToExcelDropdownComponent } from "./export-to-excel-dropdown/export-to-excel-dropdown.component";
import { XlTemplateLibraryComponent } from "./xl-template-library/xl-template-library.component";
import { LeftTabModalDesignComponent } from "./left-tab-modal-design/left-tab-modal-design.component";
import { RevisionPeriodSelectComponent } from "./revision-period-select/revision-period-select.component";
import { GlobalUserSettingsButtonComponent } from "./global-user-settings-button/global-user-settings-button.component";
import { ToggleFilterComponent } from "./toggle-filter/toggle-filter.component";
import { ComparisonGridComponent } from "./comparison-grid/comparison-grid.component";
import { MatTableModule } from "@angular/material/table";
import { PreviewListModule } from "@va/core-library/preview-list";
import { AlertsPopoverModule } from "@va/core-library/alerts-popover";
import { ToggleCheckboxComponent } from "./toggle-checkbox/toggle-checkbox.component";
import { ValuationInfoHeaderComponent } from "./valuation-info-header/valuation-info-header.component";
import { DataRevisionsDropdownComponent } from "./data-revisions-dropdown/data-revisions-dropdown.component";
import { ResearchDateFilterComponent } from "./research-date-filter/research-date-filter.component";
import { ColumnPickerModalComponent } from "./column-picker-modal/column-picker-modal.component";
import { ItemPickerModule } from "@va/core-library/item-picker";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NZ_I18N, en_US as enUS } from "ng-zorro-antd/i18n";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzTreeModule } from "ng-zorro-antd/tree";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzSliderModule } from "ng-zorro-antd/slider";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCascaderModule } from "ng-zorro-antd/cascader";
import { NzGridModule } from "ng-zorro-antd/grid";

import { LineitemFilterComponent } from "./lineitem-filter/lineitem-filter.component";
import { CascaderModule } from "@va/core-library/cascader";
import { ComparativeSearchMenuComponent } from "./comparative-search-menu/comparative-search-menu.component";
import { MarketCapFilterComponent } from "./market-cap-filter/market-cap-filter.component";
import { GeographyFilterComponent } from "./geography-filter/geography-filter.component";

import { IndustryMenuComponent } from "./industry-menu/industry-menu.component";
import { MenuListComponent } from "./menu-list/menu-list.component";
import { SystemMenuComponent } from "./system-menu/system-menu.component";
import { WatchlistSearchMenuComponent } from "./watchlist-search-menu/watchlist-search-menu.component";
import { ButtonModule } from "@va/core-library/button";
import { InViewportDirective } from "./in-viewport.directive";
import { ComparativeSearchMenuContentComponent } from "./comparative-search-menu-content/comparative-search-menu-content.component";
import { GrowthRevisionFilterV2Component } from "./growth-revision-filter-v2/growth-revision-filter-v2.component";
import { CompanyAnnouncementDialogComponent } from "./company-announcement-dialog/company-announcement-dialog.component";

import { DialogModule } from "@angular/cdk/dialog";
import { NzLayoutModule } from "ng-zorro-antd/layout";

const sharedRoutes: Routes = [
  {
    path: "templatelibrary",
    component: XlTemplateLibraryComponent,
    data: {
      title: "Template Library",
      clientFacing: true,
    },
  },
];

@NgModule({
  declarations: [
    LineitemSearchComponent,
    TickerSearchComponent,
    ActivityFeedComponent,
    TextHighlightPipe,
    EllipsisPipe,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    ArkContainerComponent,
    WatchlistDropdownComponent,
    YearTypeFilterComponent,
    RemoveWhiteSpacesPipe,
    CommonModalComponent,
    AccountingBasisComponent,
    RightPanelSourceComponent,
    AnalyticsComponent,
    HistoricalEstimatesComponent,
    PeriodsComponent,
    ValueRendererComponent,
    AddModalSectionComponent,
    RemoveModalSectionComponent,
    StepperBaseButtonComponent,
    VisualizationsComponent,
    ExportToExcelComponent,
    NullCleanerPipe,
    SourceNameTableDisplayComponent,
    InferredDataSectionComponent,
    MultiSelectFilterComponent,
    DateRangeSelectComponent,
    ComparativeAnalysisPopoverContentComponent,
    CustomSkeletonComponent,
    LineItemModalComponent,
    SourceTableComponent,
    LineitemWithSearchboxInDropdownComponent,
    GrowthRevisionFilterComponent,
    TickerFyInfoComponent,
    ExportToExcelDropdownComponent,
    LeftTabModalDesignComponent,
    RevisionPeriodSelectComponent,
    GlobalUserSettingsButtonComponent,
    ToggleFilterComponent,
    ComparisonGridComponent,
    ToggleCheckboxComponent,
    ValuationInfoHeaderComponent,
    DataRevisionsDropdownComponent,
    ResearchDateFilterComponent,
    ColumnPickerModalComponent,
    XlTemplateLibraryComponent,
    LineitemFilterComponent,
    ComparativeSearchMenuComponent,
    MarketCapFilterComponent,
    IndustryMenuComponent,
    MenuListComponent,
    SystemMenuComponent,
    WatchlistSearchMenuComponent,
    GeographyFilterComponent,
    InViewportDirective,
    ComparativeSearchMenuContentComponent,
    GrowthRevisionFilterV2Component,
    CompanyAnnouncementDialogComponent,
  ],
  imports: [
    RouterModule.forChild(sharedRoutes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    InfiniteScrollModule,
    RouterModule,
    MatListModule,
    NzEmptyModule,
    NzCheckboxModule,
    NzInputModule,
    NzSkeletonModule,
    NzModalModule,
    NzSwitchModule,
    NzTableModule,
    NzSelectModule,
    NzRadioModule,
    NzDatePickerModule,
    NzTabsModule,
    NzTreeModule,
    NzDropDownModule,
    NzDividerModule,
    NzCollapseModule,
    NzSliderModule,
    NzPopoverModule,
    AlertsModule,
    DragDropModule,
    ScrollingModule,
    MatTableModule,
    PreviewListModule,
    AlertsPopoverModule,
    ItemPickerModule,
    NzIconModule,
    NzToolTipModule,
    NzSpinModule,
    NzButtonModule,
    NzCascaderModule,
    NzGridModule,
    CascaderModule,
    ButtonModule,
    DialogModule,
    NzLayoutModule,
  ],
  bootstrap: [],
  exports: [
    AlertsModule,
    LineitemSearchComponent,
    TickerSearchComponent,
    ActivityFeedComponent,
    TextHighlightPipe,
    EllipsisPipe,
    MultiSelectDropdownComponent,
    SingleSelectDropdownComponent,
    ArkContainerComponent,
    WatchlistDropdownComponent,
    YearTypeFilterComponent,
    AccountingBasisComponent,
    RightPanelSourceComponent,
    AnalyticsComponent,
    HistoricalEstimatesComponent,
    PeriodsComponent,
    ValueRendererComponent,
    AddModalSectionComponent,
    RemoveModalSectionComponent,
    StepperBaseButtonComponent,
    VisualizationsComponent,
    ExportToExcelComponent,
    NullCleanerPipe,
    SourceNameTableDisplayComponent,
    InferredDataSectionComponent,
    MultiSelectFilterComponent,
    DateRangeSelectComponent,
    ComparativeAnalysisPopoverContentComponent,
    CustomSkeletonComponent,
    LineItemModalComponent,
    SourceTableComponent,
    LineitemWithSearchboxInDropdownComponent,
    GrowthRevisionFilterComponent,
    TickerFyInfoComponent,
    ExportToExcelDropdownComponent,
    LeftTabModalDesignComponent,
    RevisionPeriodSelectComponent,
    GlobalUserSettingsButtonComponent,
    ToggleFilterComponent,
    ComparisonGridComponent,
    ToggleCheckboxComponent,
    ValuationInfoHeaderComponent,
    ResearchDateFilterComponent,
    ColumnPickerModalComponent,
    DataRevisionsDropdownComponent,
    XlTemplateLibraryComponent,
    LineitemFilterComponent,
    ComparativeSearchMenuComponent,
    MarketCapFilterComponent,
    IndustryMenuComponent,
    MenuListComponent,
    SystemMenuComponent,
    WatchlistSearchMenuComponent,
    GeographyFilterComponent,
    InViewportDirective,
    ComparativeSearchMenuContentComponent,
    GrowthRevisionFilterV2Component,
    CompanyAnnouncementDialogComponent,
  ],
  providers: [{ provide: NZ_I18N, useValue: enUS }],
  entryComponents: [CommonModalComponent, LineItemModalComponent],
})
export class SharedModule {}
